"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningParser = exports.MiningIndexLayout = exports.MiningLayout = void 0;
const BufferLayout = __importStar(require("buffer-layout"));
const Layout = __importStar(require("../../utils/layout"));
exports.MiningLayout = BufferLayout.struct([
    BufferLayout.u8('version'),
    Layout.publicKey("owner"),
    Layout.publicKey("lendingMarket"),
    BufferLayout.u8("reservesLen"),
    Layout.uint128("unclaimedMine"),
    BufferLayout.blob(56 * 10, "dataFlat"),
]);
exports.MiningIndexLayout = BufferLayout.struct([
    Layout.publicKey("reserve"),
    Layout.uint64("unCollLTokenAmount"),
    Layout.uint128("index"),
]);
const MiningParser = (pubkey, info) => {
    const buffer = Buffer.from(info.data);
    const { version, owner, lendingMarket, reservesLen, unclaimedMine, dataFlat } = exports.MiningLayout.decode(buffer);
    const miningIndicesBuffer = dataFlat.slice(0, reservesLen * exports.MiningIndexLayout.span);
    const miningIndices = BufferLayout.seq(exports.MiningIndexLayout, reservesLen).decode(miningIndicesBuffer);
    const mining = {
        version,
        owner,
        lendingMarket,
        miningIndices,
        unclaimedMine,
    };
    const details = {
        pubkey,
        account: Object.assign({}, info),
        info: mining,
    };
    return details;
};
exports.MiningParser = MiningParser;
